import { ref } from 'vue'
import { SfLog } from '@app/adapters/logger'
import * as MeetingsApi from '@app/application/client_meetings/api/meetings'
import type {
  UseExportParams,
  UseExportReturn,
} from '@app/application/client_meetings/types'

export default function useExport({
  meetingId,
}: UseExportParams): UseExportReturn {
  const exportInProgress = ref(false)

  async function generateExport(): Promise<{ url: string } | void | null> {
    exportInProgress.value = true

    try {
      const response = await MeetingsApi.generateExport(meetingId)

      exportInProgress.value = false

      if (!response) {
        return null
      }

      return response
    } catch (error) {
      exportInProgress.value = false
      SfLog.error('Error generating export', { error })
    }
  }

  return {
    exportInProgress,
    generateExport,
  }
}
